import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import FooterStyle from './FooterStyle.module.css'
import { connect } from 'react-redux'
import ChangeLocationPopUp from '../ChangeLocationPopUp';
import LocationPopUpGuest from '../LocationPopUpGuest';
import moblogo from '../../assets/moblogo.svg'
import xlogo from '../../assets/xlogo.png'

class Footer extends Component {

    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.state = {}
    }

    openModal = () => {
        this.setState({ open: true });
    }
    closeModal = () => {
        this.setState({ open: false });
    }

    render() {

        return (
            <footer className={FooterStyle.footer}>
                <div className={this.props.content_page !== 'ListingPage' ? FooterStyle.siteFooterCenter : window.innerWidth < 1340 ? FooterStyle.siteFooterCenter : FooterStyle.siteFooter}>
                    <div className={`${FooterStyle.siteFooterWrap} grid-main`}>
                        <ul className={'grid-main text-center col-md-12'}>
                            <ul>
                                <li className="list-inline-item">
                                    <Link to="/about-us" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>About Us</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/how-to-earn" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>How to Earn?</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/promote" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>How to Promote?</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/tutorials" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Tutorials</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/announcements" className={`${FooterStyle.footerLink} social-icon text-xs-center`}> Announcements</Link>
                                </li>
                                {/* <li className="list-inline-item">
                                    <Link to="/knowledge-base" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Knowledge Base</Link>
                                </li> */}
                                <li className="list-inline-item">
                                    <Link to="/success-story" className={`${FooterStyle.footerLink} social-icon text-xs-center`}> Success Stories</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/terms-of-service" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Terms &amp; Conditions</Link>
                                </li><br></br>
                                <li className="list-inline-item">
                                    <Link to="/privacy-policy" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Privacy Policy</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/cookies-policy" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Cookie Policy</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/advertisement-policy" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Advertisement Policy</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/content-policy" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Content Policy</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/refund-policy" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Refund Policy</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/we-are-at" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>We Are At</Link>
                                </li>
                                <li className="list-inline-item">
                                    {this.props.is_login ? <Link className={`${FooterStyle.footerLink} social-icon text-xs-center`} onClick={this.openModal}>Change Location</Link> : <Link className={`${FooterStyle.footerLink} social-icon text-xs-center`} onClick={this.openModal}>Set Location</Link>}
                                </li>
                                <li className="list-inline-item">
                                    <div className='large_rect'><Link to="/contact" className={`${FooterStyle.footerLink} social-icon text-xs-center`}>Contact Support Form</Link></div>
                                </li>
                            </ul>
                            <div className={`container ${FooterStyle.board}`}>
                                <div className='follow'>
                                    <h2>Follow Us On:</h2>
                                </div>
                                <div>
                                    <a href="https://www.facebook.com/AajuBaaju.eClassifieds" className='fass fa fa-facebook' target="_blank"></a>
                                </div>
                                <div>
                                    <a href="https://www.youtube.com/@ameereebadaao" target="_blank" className='fass fa fa-youtube'></a>
                                </div>
                                <div>
                                    <a href="https://www.linkedin.com/company/aajubaaju" target="_blank" className='fass fa fa-linkedin'></a>
                                </div>
                                <div>
                                    <a href="https://x.com/AajuBaajuian" target="_blank"><img className="img-fluid fasLogo" src={xlogo} alt="Founders Desk" /></a>
                                </div>
                                <div>
                                    <a href="https://aajubaaju.in/content/All/AajuBaaju-Founders'-Desk/all" target="_blank"><img className="img-fluid fasLogo" src={moblogo} alt="Founders Desk" /></a>
                                </div>
                            </div>
                            {this.props.is_login ? <ChangeLocationPopUp open={this.state.open} closeModal={this.closeModal} /> : <LocationPopUpGuest open={this.state.open} closeModal={this.closeModal} />}
                            <li className="list-inline-item">
                                © 2021 Copyright AajuBaaju eClassifieds Private Limited. All Rights Reserved.
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
        )
    }
}

const mapStateToProps = state => {
    return {
        is_login: state.is_login,
        content_page: state.content_page,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        isLogin: (is_login) => dispatch({ type: 'IS_LOGIN', is_login: is_login }),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));